import { ReactNode } from 'react'
import './LargeBody.scss'

interface Props {
  children: ReactNode
}
export const LargeBody = ({ children }: Props) => {
  return <div className="cms-large-body">{children}</div>
}
